import baseAPI from '@/api/base';
import {
  EditAnnouncement,
  GetAnnouncement,
  MoveAnnouncementToFolder,
  MoveAnnouncementsToFolder,
  RegisterAnnouncement,
} from '@/dtos/announcement.dto';
import {
  BULK_DELETE_ANNOUNCEMENTS_URL,
  BULK_MOVE_ANNOUNCEMENTS_TO_FOLDER_URL,
  DELETE_ANNOUNCEMENT_URL,
  EDIT_ANNOUNCEMENT_URL,
  GET_ANNOUNCEMENT_URL,
  MOVE_ANNOUNCEMENT_TO_FOLDER_URL,
  REGISTER_ANNOUNCEMENT_URL,
  TOGGLE_ANNOUNCEMENT_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Announcement {
  static getAnnouncements = async (
    getAnnouncement: GetAnnouncement
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ANNOUNCEMENT_URL, {
      params: getAnnouncement,
    });
    console.log('response', response);
    return response;
  };

  static registerAnnouncement = async (
    registerAnnouncement: RegisterAnnouncement
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_ANNOUNCEMENT_URL,
      {
        ...registerAnnouncement,
      }
    );
    console.log('response', response);
    return response;
  };

  static editAnnouncement = async (
    editAnnouncement: EditAnnouncement
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_ANNOUNCEMENT_URL,
      {
        ...editAnnouncement,
      }
    );
    return response;
  };

  static toggleAnnouncementIsActive = async (
    editAnnouncement: EditAnnouncement
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ANNOUNCEMENT_IS_ACTIVE_URL,
      {
        ...editAnnouncement,
      }
    );
    return response;
  };

  static moveAnnouncementToFolder = async (
    moveAnnouncementToFolder: MoveAnnouncementToFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      MOVE_ANNOUNCEMENT_TO_FOLDER_URL,
      {
        ...moveAnnouncementToFolder,
      }
    );
    return response;
  };

  static moveAnnouncementsToFolder = async (
    payload: MoveAnnouncementsToFolder
  ): Promise<AxiosResponse> => {
    return baseAPI.patch(BULK_MOVE_ANNOUNCEMENTS_TO_FOLDER_URL, payload);
  };

  static deleteAnnouncement = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ANNOUNCEMENT_URL}/${id}`
    );
    return response;
  };

  static deleteAnnouncements = async (
    ids: string[]
  ): Promise<AxiosResponse> => {
    return baseAPI.delete(BULK_DELETE_ANNOUNCEMENTS_URL, {
      data: { ids },
    });
  };
}

export default Announcement;
